export const calculateFromGear = (D, gW, d) => {
	if (!D || !gW || !d || D < 0 || gW < 0 || d < 0) {
		throw new Error("Please, verify your input values");
	}
	if (d >= D) {
		throw new Error(
			"Please, verify your input values, d must be smaller than D"
		);
	}
	return {
		displacement: (gW * Math.PI * (D * D - d * d)) / 4,
		bodyWidth: D + d + (D - d) / 2,
		centerDistance: (d + D) / 2,
	};
};

export const calculateFromBody = (D, gW, W) => {
	if (!D || !gW || !W || D < 0 || gW < 0 || W < 0) {
		throw new Error("Please, verify your input values");
	}
	if (W >= 2 * D) {
		throw new Error(
			"Please, verify your input values, W must be smaller than 2D"
		);
	}
	return {
		displacement: gW * Math.PI * (W - D) * (2 * D - W),
		internalDiameter: 2 * W - 3 * D,
		centerDistance: W - D,
	};
};

export const calculateFromCenters = (D, gW, c) => {
	if (!D || !gW || !c || D < 0 || gW < 0 || c < 0) {
		throw new Error("Please, verify your input values");
	}
	if (c >= D) {
		throw new Error(
			"Please, verify your input values, c must be smaller than D"
		);
	}
	return {
		displacement: gW * Math.PI * c * (D - c),
		internalDiameter: 2 * c - D,
		bodyWidth: c + D,
	};
};

export const cubicInchesToCm = (inches) => {
	// if (!inches || inches < 0) {
	// 	throw new Error("Please, verify your input values");
	// }
	return inches * 16.387;
};

export const cubicCmToInches = (cm) => {
	// if (!cm || cm < 0) {
	// 	throw new Error("Please, verify your input values");
	// }
	return cm / 16.387;
};
